import * as React from "react";
import classnames from "classnames";
import { Button } from "@grandvisionhq/common";
/* empty css                                                         */
const AddToCart = ({ className, ...props }) => /* @__PURE__ */ React.createElement(Button, { "data-t": "add-to-cart", className: classnames("add-to-cart", className), ...props });
export {
  AddToCart
};
//# sourceMappingURL=AddToCart.js.map
